<main class="container">
    <div class="row">
        <div class="col-sm-12 col-sm-offset-0">
            <div class="panel panel-default" id="layoutPanel">
                <div class="panel-heading" id="layoutPanelHeading">
                    <strong>{{Title}}</strong>
                </div>
                <div class="panel-body" id="layoutPanelBody">
                    <b>
                        {{DisplayMessage}}
                    </b>
                    <br />
                    <br />
                    <p></p>
                    <b>Get the CellGate App</b>
                    <br />
                    <p></p>
                    <b>Download the app and login to manage access anytime, anywhere.</b>
                    <br />
                    <p></p>
                    <ul class="listStyle">
                        <li>
                            <p>Click here for: <a target="_blank" href="https://apps.apple.com/us/app/cellgate-mobile-connect/id575775114">Apple iOS</a><a class="highlightColor"> <b style="color: black;">→</b></a> <a target="_blank"
                                    href="https://apps.apple.com/us/app/cellgate-mobile-connect/id575775114"><img
                                        src="http://admin.zapopen.com/public/images/iOSLogo.png"> </a> </p>
                        </li>
                        <li>
                            <p>Click here for:<a target="_blank" href="https://play.google.com/store/apps/details?id=com.celaccess&hl=en_US"> Android </a>  <a class="highlightColor"> <b style="color: black;">→</b></a> <a target="_blank"
                                    href="https://play.google.com/store/apps/details?id=com.celaccess&hl=en_US"><img
                                        src="http://admin.zapopen.com/public/images/AndroidLogo.png"></a> </p>
                        </li>
                         <li style="list-style-type: none;">
                      <img src="public/images/cellgateapp_login.png" alt="CellGate App" />
                    </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

</main>